import {Autocomplete, InputAdornment, TextField} from "@mui/material";
import {useFormikContext} from "formik";
import React, {useCallback, useEffect, useState} from "react";
import {useMap, useMapsLibrary} from "@vis.gl/react-google-maps";
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

type GooglePlacesAutocompleteProps = {
    value: any;
    setValue: any;
    fieldName: string
    minAutocompleteLength: number;
    placeholder?: string;

}

export default function GooglePlacesAutocomplete({
                                                     fieldName,
                                                     minAutocompleteLength,
                                                     value,
                                                     setValue,
                                                     placeholder = "Find Locations Near..."
                                                 }
                                                     : GooglePlacesAutocompleteProps) {

    const formik = useFormikContext<any>()

    const map = useMap();
    const placesLibrary = useMapsLibrary('places');
    const [placesService, setPlacesService] = useState<any>();
    useEffect(() => {
        if (!placesLibrary || !map) return;
        setPlacesService(new placesLibrary.PlacesService(map));
    }, [placesLibrary, map]);

    const [options, setOptions] = useState<any[]>([])

    const handleFieldChange = async (event: any) => {
        await formik.setFieldValue(fieldName, event.target.value)
        if (event.target.value.length >= minAutocompleteLength) {
            placesService?.textSearch({
                query: event.target.value,
                language: 'en',
                region: 'us'
            }, (a: any, b: any, c: any) => {
                if (b === "OK")
                    setOptions(a?.slice(0, 5) ?? [])
            })
        } else
            setOptions([])
    }

    const handleValueChange = async (event: any, value: any) => {
        setValue(value)
        await formik.setFieldValue(fieldName, value?.formatted_address)
    }

    const renderAutocomplete = useCallback(() => {
        return <Autocomplete
            autoSelect={true}
            options={options}
            value={value}
            onChange={handleValueChange}
            getOptionKey={option => option?.placeId}
            getOptionLabel={option => option?.formatted_address}
            filterOptions={(options) => options}
            autoHighlight={true}
            noOptionsText={"No suggestions found"}
            renderInput={(params) => {
                return <TextField {...params}
                                  value={formik?.values?.[fieldName]}
                                  onChange={handleFieldChange}
                                  placeholder={placeholder}
                                  InputProps={{
                                      ...params.InputProps,

                                      startAdornment:
                                          <InputAdornment position="start">
                                              <GpsFixedIcon/>
                                          </InputAdornment>,

                                  }}
                />
            }}
        />
    }, [options, formik?.values?.[fieldName], handleFieldChange])

    return renderAutocomplete()
}